/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {useTranslation} from "react-i18next";
import React, { useState} from "react";
import {
    EMPTY_VALUES,
} from "../../../../../../Apis/functions";
import CustomChip from "../../../../../../components/CustomChip";
import {
    chipStatusIconClassColor,
    statusBorderColor,
    statusColor,
    statusFontColor
} from "../../../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../../../enums/statusEnum";
import {REQUEST_DOCUMENTATION_ICON_MODEL} from "../../../../../Contractor/Documentation/Model/Model";
import MaterialDispatchCard from "./MaterialDispatchCard";
import MaterialRecordDeliveryModal from "../../../Modal/MaterialRecordDeliveryModal";
import {CustomLevelCardStyle} from "../../../../../../components/Styles";
import {FILE_MODEL} from "../../../../Visitor/Visitor/Model/Model";
import {
    getMaterialRequestDispatchStatusId,
    wasMaterialControlDispatched
} from "../../../Model/Model";
import {CubeIcon} from "../../../../../../components/buttons/IconButtons";
import EntryAndExitFormDiscrepancyCard from "../../EntryAndExitForms/Details/EntryAndExitFormDiscrepancyCard";

const MaterialDispatchListSection = ({
                                         data,
                                         setModified,
                                         contentTableRef,
                                         emptyFields,
                                         disabled = false,
                                         cardStatusId = null,
                                         showDraftEvidence = false
                                     }) => {
    const { t } = useTranslation();
    const statusId = getMaterialRequestDispatchStatusId(data?.dispatchStatusId);
    const IconComponent = REQUEST_DOCUMENTATION_ICON_MODEL[statusId] || (() => null);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    // The list is read beside the information of the folio, so it is bordered
    // with the status that card is bordered with and both close the same block
    const styles = CustomLevelCardStyle(cardStatusId, false);
    // The materials of a folio that already handed them over have nothing left
    // to validate, so the list is only read from that moment
    const isDispatched = wasMaterialControlDispatched(data);
    // The evidence a material carries is a draft of the gate until the dispatch
    // is registered, so the review of the folio only reads it once the materials
    // were dispatched, while the gate always reads the draft it wrote itself,
    // even once the list is only read because the folio was reported
    const showEvidence = !disabled || isDispatched || showDraftEvidence;

    return (
        <>
            <div style={styles.container}>
                <div className='d-flex justify-content-between align-items-center h-72px' style={styles.levelCard}>
                    <div className={"d-flex align-items-center"}>
                        <div className={"mr-2"}><CubeIcon/></div>
                        <p className={"fs-16px ibl-font-w-600"}> {t(isDispatched ? "materials" : "materials_for_validate")}</p>
                    </div>


                    { statusId &&
                    <CustomChip
                        variant={'large'}
                        icon={<IconComponent className={`${chipStatusIconClassColor[statusId]}`}/>}
                        background={statusColor[statusId]}
                        fontColor={statusFontColor[statusId]}
                        borderColor={statusBorderColor[statusId]}
                        legend={t(status[statusId]) || EMPTY_VALUES.DEFAULT}
                        classNameIcon={"w-h-24px"}
                        className={"py-2 px-12px h-40px minh-40px maxh-40px"}
                    />
                    }
                </div>
                <div ref={contentTableRef} className={"overflow-y-auto"}>
                    <div className={"row mt-3"}>
                        { data?.items?.map((item, index) => {
                            const evidence = item?.itemEvidence || null;
                            const statusId = evidence ? STATUS_MODEL.DRAFT : STATUS_MODEL.PENDING ;
                            // The material is read inside the block, so it is
                            // bordered the same way the block and the
                            // information of the folio beside it are
                            let styles = CustomLevelCardStyle(cardStatusId, false);
                            const file = evidence ? FILE_MODEL.set(evidence) : null;

                            return (
                                <div className={"col-12 mb-3"} key={item?.id ?? index}>
                                    {/* A material read without its evidence has
                                    nothing to validate, so it is displayed with
                                    the card every detail reads a material with. */}
                                    {showEvidence ?
                                        <MaterialDispatchCard
                                            t={t}
                                            item={item}
                                            file={file}
                                            statusId={statusId}
                                            setShowModal={setShowModal}
                                            setItemSelected={setItemSelected}
                                            styles={styles}
                                            disabled={disabled}
                                            emptyFields={emptyFields}
                                        />
                                        :
                                        <EntryAndExitFormDiscrepancyCard
                                            t={t}
                                            item={item}
                                            file={null}
                                        />
                                    }
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            { showModal &&
                <MaterialRecordDeliveryModal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    itemSelected={itemSelected}
                    setModified={setModified}
                />
            }

        </>
    );
};

export default MaterialDispatchListSection;
